import React from 'react'

const StudentSubject = () => {
  return (
    <div>StudentSubject</div>
  )
}

export default StudentSubject